import { render } from "./JournalSender.vue?vue&type=template&id=1f4a3cf0"
import script from "./JournalSender.vue?vue&type=script&lang=js"
export * from "./JournalSender.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__